import { PIPELINE_COMPLETION_TIMEOUT_MAX_MIN } from './constant';

export default (dateInput) => {

  const oneHourAgo = Date.now() - PIPELINE_COMPLETION_TIMEOUT_MAX_MIN * 60 * 1000;
  const isOneHourAgo = dateInput?.getTime() < oneHourAgo;
  return isOneHourAgo;
};
